export default "__VITE_ASSET__Byp9wSBO__"